import PayrollList from "./list";

const payrollComponents = {
  list: PayrollList,
};

export default payrollComponents;
